import React, { FC, useCallback } from 'react';
import { Layout, Row, Col, Card } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import BidderList from '../bidder_list/BidderList';
import FileUploader from '../file_uploader/FileUploader';
import {
	requestsForProposalRestCrudThunksForBuyer,
	requestsForProposalRestCrudThunksForSupplier,
} from '../../thunks/requests_for_proposal_thunks';

import { getRecordsForTargetCollection } from '../../reducers/standard_reducer_utils';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { EmptyState } from '../empty_state/EmptyState';
import WorkOrderRowDisplay from '../work_order_row_display/WorkOrderRowDisplay';
import { compareStrings, getEntityById, nullSafeGet } from '../../utils/DataAccessUtils';
import RFPTotalSpend from './RFPTotalSpend';
import { ROLE_TYPES } from '../../utils/DataConstants';

const { Content } = Layout;
require('./RFPDetailDetailsPage.less');

const RFPDetailDetailsPage: FC<any> = ({
	history,
	requestForProposal,
	updateRequestForProposal,
	biddersFetching,
	requestsForProposalFetching,
	bidders,
	userType,
}): React.ReactElement => {
	const handleFileAttachmentUploadChange = useCallback(
		(newAttachments) => {
			const newRequestForProposal = {
				...requestForProposal,
				attachments: newAttachments,
			};
			updateRequestForProposal(newRequestForProposal);
		},
		[requestForProposal, updateRequestForProposal]
	);

	const fetching = [requestsForProposalFetching, biddersFetching].some(
		(fetchingStatus) => fetchingStatus === true
	);

	const associatedBidders = getRecordsForTargetCollection(bidders, 'RFP_DETAIL_BIDDERS');

	return fetching ? (
		<PageLoadingPlaceholder />
	) : (
		<Content className="rfpDetailDetailsPage" style={{ padding: '0 0.5em' }}>
			<Row style={{ margin: '-0.25em -8px 0.5em -8px' }} gutter={16}>
				<Col span={16}>
					{requestForProposal.description && requestForProposal.description !== '<p><br></p>' ? (
						<Row gutter={16} className="rowSpacing">
							<Col span={24}>
								<Card title="About the RFP">
									<div
										style={{ fontSize: 16, marginBottom: 24 }}
										className="richTextWrapper"
										dangerouslySetInnerHTML={{ __html: requestForProposal.description }}
									/>
								</Card>
							</Col>
						</Row>
					) : null}
					<Row gutter={16} className="rowSpacing">
						<Col span={24}>
							<div
								onClick={() =>
									history.push(
										`/${userType}/workOrders/detail/${nullSafeGet(
											'workOrder.id',
											requestForProposal
										)}`
									)
								}
							>
								<Card title="About the Problem">
									<WorkOrderRowDisplay workOrder={requestForProposal.workOrder} />
								</Card>
							</div>
						</Col>
					</Row>
					<Row gutter={16} className="rowSpacing">
						<Col span={24}>
							<Card title="Bidders">
								{biddersFetching || associatedBidders.length === 0 ? (
									<EmptyState
										graphic={
											<img
												style={{ marginBottom: 8 }}
												src="https://s3.amazonaws.com/mock-data-assets/categories/images/Lamp.svg"
												alt="It's a little lonely in here."
											/>
										}
										headline={"It's a little lonely in here."}
										body={
											<div style={{ textAlign: 'center', maxWidth: 480 }}>
												This RFP isn't going to bid on itself. How about inviting some service
												providers from your network to quote?
											</div>
										}
									/>
								) : (
									<BidderList bidders={associatedBidders} requestForProposal={requestForProposal} />
								)}
							</Card>
						</Col>
					</Row>
				</Col>

				<Col span={8}>
					{requestsForProposalFetching ? null : (
						<>
							{compareStrings(nullSafeGet('status', requestForProposal), 'award') ? (
								<Row gutter={16} className="rowSpacing">
									<Col span={24}>
										<RFPTotalSpend bidders={associatedBidders} />
									</Col>
								</Row>
							) : null}
							<Row gutter={16} className="rowSpacing">
								<Col span={24}>
									<Card title="File Attachments">
										<FileUploader
											roleType={userType}
											defaultFileList={requestForProposal.attachments || []}
											handleUploadSuccess={handleFileAttachmentUploadChange}
											uploaderType={'dragger'}
										/>
									</Card>
								</Col>
							</Row>
						</>
					)}
				</Col>
			</Row>
		</Content>
	);
};

const mapStateToProps = (state, ownProps) => ({
	requestsForProposalFetching: state.requests_for_proposal.fetching,
	requestForProposal: getEntityById(ownProps.match.params.id, state.requests_for_proposal),
	bidders: state.bidders,
	biddersFetching: state.bidders.fetching,
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	updateRequestForProposal: (entity) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? requestsForProposalRestCrudThunksForSupplier.update(entity)
				: requestsForProposalRestCrudThunksForBuyer.update(entity)
		),
});

const RFPDetailDetailsConnectedPage = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(RFPDetailDetailsPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(RFPDetailDetailsConnectedPage);
